































































































































































































































































import { Component, Prop, Vue, Watch, Inject } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { User, UserCap, UserPaymode } from '@/data/models/user.model';
import { CrudService } from '@/data/services/crud.service';
import { cloneDeep } from 'lodash';
import { currencyToNumber, newDate, numberMask } from '@/data/utils/helper';
import { Search } from '@/data/models/search.model';
import { Page } from '@/data/models/page.model';
import { plainToClassFromExist } from 'class-transformer';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider,
	},
})
export default class UtenteFattorino extends Vue {
	@Prop() utente!: User;
	@Prop() editable!: boolean;

	@Inject('CrudService') userCrudService!: CrudService<User>;
	@Inject('CrudService') userCapCrudService!: CrudService<UserCap>;

	newUtente!: User;
	userCaps: UserCap[] = [];

	minyear: number = 1900;
	maxyear: number = newDate().getFullYear();

	paymodeItems: string[] = Object.keys(UserPaymode).map(
		// @ts-ignore
		(k: string) => UserPaymode[k]
	);

	numberMask: any = numberMask();

	currencies: any = {};

	constructor() {
		super();
		this.newUtente = new User();
	}

	@Watch('utente', { immediate: true })
	onUserChange() {
		this.newUtente = cloneDeep(this.utente);
		this.setCurrency(this.newUtente, 'centperkm');
		this.setCurrency(this.newUtente, 'daylyrevenue');
		this.setCurrency(this.newUtente, 'revenueperenvelope');
		this.loadUserCaps();
	}

	loadUserCaps() {
		const search = new Search('usercap');
		search.addSimpleFilter('userid', this.utente.id);
		this.userCapCrudService.searchEntities(UserCap, 'usercap', search, new Page(100)).then(result => this.userCaps = result);
	}

	addCap() {
		const uc = new UserCap();
		uc.userid = this.utente.id;
		this.userCaps.push(uc);
	}

	removeCap(uc: UserCap) {
		const index = this.userCaps.indexOf(uc);
		if (uc.id) {
			this.userCapCrudService.deleteEntity(UserCap, 'usercap', uc).then(() => {
				this.$buefy.notification.open({
					message: this.$t('success-save') as string,
					type: 'is-success',
				});
				this.userCaps.splice(index, 1);
			}).catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
		} else {
			this.userCaps.splice(index, 1);
		}
	}

	saveCap(uc: UserCap) {
		this.userCapCrudService.createEntity(UserCap, 'usercap', uc).then(result => {
			this.$buefy.notification.open({
				message: this.$t('success-save') as string,
				type: 'is-success',
			});
			plainToClassFromExist(uc, result);
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

	onCurrencyChange(event: any, field: string) {
		this.currencies[field] = currencyToNumber(event.target._vCleave.getFormattedValue());
	}

	submit() {
		const u = cloneDeep(this.newUtente);
		Object.keys(this.currencies).forEach(k => {
			this.$set(u, k, this.currencies[k]);
		});
		this.userCrudService.createEntity(User, 'user', u).then(result => {
			this.$buefy.notification.open({
				message: this.$t('success-save') as string,
				type: 'is-success',
			});
			this.newUtente = result;
			this.$emit('update:utente', result);
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

	private setCurrency(object: any, field: string) {
		const val = object[field];
		if (typeof val === 'undefined' || val === null) return;
		this.$set(object, field, val.toString().replace('.', ','));
	}
	
}
